<template>
  <div class="py-2">
    {{
      team.rankingPosition < 10
        ? `0${team.rankingPosition}`
        : team.rankingPosition
    }}
  </div>
  <div
    class="flex flex-row rounded-lg px-4 py-2 justify-between w-full mb-2 border border-light-gray"
    :class="[team.isTeamOfCurrentUser ? 'bg-bkk-50' : 'bg-bkk-10']"
  >
    <div class="text-medium flex flex-row items-center">
      {{ team.name }}
    </div>
    <div class="flex flex-row gap-x-16">
      <div class="flex flex-col pr-16">
        <div class="font-bold">
          {{
            rankingSortType === RankingSortType.RANKING_SORT_TOTAL
              ? formatProgressValue(team?.totalProgress)
              : formatProgressValue(team?.averageProgress)
          }}
        </div>
        <div
          v-if="
            teamChallengeType ===
            CompetitiveChallengeType.COMPETITIVE_CHALLENGE_TYPE_STEPS
          "
        >
          {{
            rankingSortType === RankingSortType.RANKING_SORT_AVERAGE
              ? "∅ "
              : ""
          }}{{ t("steps.semantics") }}
        </div>
        <div v-else>
          {{
            rankingSortType === RankingSortType.RANKING_SORT_AVERAGE
              ? "∅ "
              : ""
          }}{{ t("bicycle.semantics") }}
        </div>
      </div>
      <div class="flex flex-col">
        <div class="font-bold">
          {{
            t("comp.challenge.started.tab.ranking.kilogram", {
              s: formatCompetitiveChallengeCo2(
                rankingSortType === RankingSortType.RANKING_SORT_TOTAL
                  ? team?.totalCo2Saving
                  : team?.averageCo2Saving
              ),
            })
          }}
        </div>
        <div>
          {{
            rankingSortType === RankingSortType.RANKING_SORT_AVERAGE ? "∅ " : ""
          }}
          {{ t("comp.challenge.started.tab.ranking.card.co2.label") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { CompetitiveChallengeTeamDto } from "../../../dto/competitive-challenge-team.dto";
import { CompetitiveChallengeType } from "../../../enum/v2/competitive-challenge-type";
import { RankingSortType } from "../../../enum/v2/ranking-sort-type";
import {
  formatCompetitiveChallengeCo2,
  formatCompetitiveChallengeProgress,
} from "../../../plugins/NumberFormat";

const { t } = useI18n();

const props = defineProps({
  team: {
    type: Object as () => CompetitiveChallengeTeamDto,
    required: true,
  },
  teamChallengeType: {
    type: String as () => CompetitiveChallengeType,
    required: true,
  },
  rankingSortType: {
    type: String as () => RankingSortType,
    required: true,
  },
});

function formatProgressValue(value: unknown): string {
  return formatCompetitiveChallengeProgress(value, props.teamChallengeType, {
    roundUp: true,
  });
}
</script>
